// src/components/ar-guides/events.ts

/**
 * Evento DOM con el que el overlay de guías AR (ARGuideOverlay) pide al Layout
 * que abra el drawer del sidebar en mobile. Sin contexto compartido ni props
 * drilling: el overlay lo despacha cuando un paso señala ítems del sidebar que
 * quedan ocultos por el drawer cerrado, y el Layout lo escucha.
 */
export const ABRIR_SIDEBAR_EVENT = 'mcd:ar-guide:abrir-sidebar';
